import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ReactErrorBoundary from "./components/common/ErrorBoundary";
import "./style/App.css";
import "./style/globals.css";
import "react-loading-skeleton/dist/skeleton.css";
import { CircularLoader } from "./components/common/Loader";
// import Hello from "./pages/hello";
const NotFoundPage = lazy(() => import("./components/common/NotFoundPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const HomeLayout = lazy(() => import("./layout/HomeLayout"));
const OnboardingPage = lazy(() =>
  import("./pages/dashboard/dashboardPages/OnboardingPage")
);

export default function App() {
  return (
    <ReactErrorBoundary fallback={<div>Something went wrong!</div>}>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-screen">
              <CircularLoader />
            </div>
          }
        >
          <Routes>
            <Route path="/*" element={<HomeLayout />}>
              <Route index element={<DashboardPage />} />
              <Route
                path={process.env.REACT_APP_ONBOARDING_PATH}
                element={<OnboardingPage />}
              />
              <Route
                path="404"
                element={<NotFoundPage msg="404 | Page Not Found" />}
              />
              <Route path="*" element={<Navigate replace to="/404" />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ReactErrorBoundary>
  );
}
